export default __webpack_public_path__ + "static/media/github.7d98d7b2.svg";